import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function hasErrors(errors: string[] | undefined) {
  return errors && errors.length > 0;
}

export function capitalize(str?: string | null) {
  if (!str || str.length === 0) return str;
  const lower = str.toLowerCase();
  return lower.charAt(0).toUpperCase() + lower.slice(1);
}

export function enumToHumanString(str?: string | null) {
  if (!str || str.length === 0) return str;
  return str.split('_').filter(Boolean).map(capitalize).join(' ');
}

export function toTitleCase(str?: string | null) {
  if (!str || str.length === 0) return str;
  return str.split(' ').map(capitalize).join(' ');
}
